<template>
    <section class="section team-area team-style-two overflow-hidden ptb_100">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-10 col-lg-6">
                        <!-- Section Heading -->
                        <div class="section-heading text-center">
                            <h2 class="text-capitalize">Our Team</h2>
                            <p class="mt-4">Source Digital has nearly 100 employees all over the world. Here are a few key members.</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <TeamMember v-for="member in members" :key="member.name" :data="member" />
                </div>
            </div>
        </section>
</template>

<script>
import TeamMember from './TeamMember.vue'
export default {
    components: {
        TeamMember
    },
    data () {
        return {
            members: [
                {
                    photo: 'https://storage.googleapis.com/cdn.sourcesync.io/media/aa0a3acf-aa02-4e18-b296-6adf1882e68d.jpeg',
                    name: 'Hank Frecon',
                    title: 'Founder & CEO',
                    details: 'Seasoned technology leader and inventor for more than 18 years in M&E Tech. Most recently a co-founder of the successfully exited Radiant Grid, Inc. He brings an in-depth understanding of the creation to consumer dynamics of media enterprises. Understanding the challenges content owners face led to the co-founding of Source Digital.',
                    social: []
                },
                {
                    photo: 'https://storage.googleapis.com/cdn.sourcesync.io/media/5b6570d6-2337-4ca3-9fe9-3340043e2a07.jpg',
                    name: 'Laura Frecon',
                    title: 'Co-Founder',
                    details: 'Laura is a costume designer and stylist. Film and television credits include "Kong Skull Island", "Men in Black 3", "True Blood" and "Mad Men", where her team received an Emmy nomination for best period costume design. The constant flurry of requests and inquiries from fans about the iconic outfits that are featured in her works served as part of the inspiration for Source.',
                    social: []
                },
                {
                    photo: 'https://storage.googleapis.com/cdn.sourcesync.io/media/f6447bf8-bf93-4984-acee-192853db7ce5.png',
                    name: 'Michael Phillips',
                    title: 'Chief Product Officer',
                    details: 'Michael is an Academy Award-winning veteran technologist and creative professional. Co-inventor of the Avid Film Composer, Michael led strategy research and development for the M&E industry. He is an expert in postproduction workflows, shaping the current and future product roadmap for Source Digital.',
                    social: []
                },
                {
                    photo: 'assets/img/team/jeff-willhoite.jpg',
                    name: 'Jeff Willhoite',
                    title: 'Chief Revenue Officer',
                    details: 'Over 20 years\' experience in business development and revenue acquisition, overseeing revenues in excess of 600M annually. Through his tenure with Shell and Sonic and the founding of Ferociti his disciplines range across supply chain, procurement, commercial sales, and marketing.',
                    social: []
                },
                {
                    photo: 'https://storage.googleapis.com/cdn.sourcesync.io/media/759ad641-1513-4a7a-b7a3-a4522593d5bf.jpg',
                    name: 'Patrick Greene',
                    title: 'Co-Founder, Architect',
                    details: 'Co-Founder of Evo and Whisper Tech, Patrick is an experienced programmer and brilliant inventor in the field of software development. He aspires to ultimately make the world a better place by treating audio as a data transport layer. Besides contributing the Whisper Tech layer, Patrick’s inventions have led to some of Source’s earliest patents.',
                    social: []
                },
                {
                    photo: 'assets/img/team/martha-snider.jpg',
                    name: 'Martha Snider',
                    title: 'VP of Strategy',
                    details: 'Martha combines her background in the creative arts and large scale media and entertainment industries with her innovative approach to business development and strategic relationship building to optimize development of both new and established companies, foundations, and ventures specializing in cultural and community relations, media, technology and entertainment.',
                    social: []
                },
                {
                    photo: 'https://storage.googleapis.com/cdn.sourcesync.io/media/741aca30-045d-4d43-b0af-8e4d819bfe5a.jpg',
                    name: 'Lesley Glorioso',
                    title: 'VP of Finance',
                    details: 'Lesley has extensive experience in finance, products, programs, and product marketing, having held key roles at Avid Technology from its founding through its explosive growth, as well as at other industry-leading M&E technology companies.',
                    social: []
                },
                {
                    photo: 'https://storage.googleapis.com/cdn.sourcesync.io/media/9959a906-d9a5-4299-a6c0-b104e6fa3c84.png',
                    name: 'Joe Callahan',
                    title: 'Contributing Founder',
                    details: 'Founder and CEO of the Ciright Companies, oversees more than 100 employees spanning several continents and over 15 brands. A serial entrepreneur with a unique mix of engineering, programming, and creative marketing, Joe is passionate about all things technology and as such is a recipient of the prestigious Ernest & Young, Entrepreneur Of The Year award.',
                    social: []
                }
            ]
        }
    }
}
</script>

<style>

</style>